module.exports = __webpack_public_path__ + "img/zifen.baa91796.png";